import { setCurrectChat, decrementMessagesUnreadCount } from "../../../../redux/user-slices/socket.slice"
import UserServices from "../../../../services/user.service"
import { useDispatch, useSelector } from "react-redux"
import OnlineBadge from "../../../common/OnlineBadge"
import { useEffect, useRef, useState } from "react"
import Icons from "../../../../assets/js/Icons"

import {
  Avatar, Box, Chip, CircularProgress, Divider, Grid2 as Grid,
  Icon, ListItemText, Paper, Stack, TextField
} from "@mui/material"

function Users() {
  const listRef = useRef()
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const userServices = new UserServices()
  const { loadings } = useSelector((state) => state.otherSlice)
  const { socket, chat } = useSelector((state) => state.socketSlice)
  const { member, specialist } = useSelector((state) => state.authSlice)

  const handleChatActive = (element) => {
    dispatch(setCurrectChat(element))
    dispatch(decrementMessagesUnreadCount(element?.unreadCount || element?.unread || 1))
    if (socket) {
      socket.emit("join-room", (element?._id))
      const currentUserId = member?._id || specialist?.specialist?._id || specialist?._id;
      socket.emit("get-chats", { userId: currentUserId, currentPage: 1, limit: 20 })
    }
  }

  useEffect(() => {
    const listElement = listRef.current

    const handleScroll = () => {
      if (
        listElement.scrollTop + listElement.clientHeight >=
        listElement.scrollHeight &&
        !loadings?.retrieveAll &&
        data?.pagination?.hasNextPage
      ) {
        // handleDebouncedFetch()
      }
    }

    listElement.addEventListener("scroll", handleScroll)
    return () => listElement.removeEventListener("scroll", handleScroll)
    // eslint-disable-next-line
  }, [socket])
  // }, [handleDebouncedFetch])

  useEffect(() => {
    if (!socket) return
    // 1. Request chats list
    socket.emit("get-chats", { userId: (member?._id || specialist?.specialist?._id || specialist?._id), currentPage: 1, limit: 20 })

    // Listen for chats list
    socket.on("chats-list", ({ data }) => {
      if (Boolean(data?.records?.length)) { setData(data) }
    })

    return () => { socket.off("chats-list") }
    // eslint-disable-next-line
  }, [socket])


  return (
    <Grid size={{ xs: 12, md: "auto" }}>
      <Paper
        sx={{
          gap: 1,
          display: "flex",
          flexDirection: "column",
          height: { xs: "520px", md: "580px" },
          maxHeight: "calc(100vh - 200px)",
          minHeight: "450px",
        }}
        variant="outlined"
        paperVariant="dashboard"
      >
        <TextField
          size="small"
          type="search"
          onChange={(e) => {
            const search = e.target.value
            socket.emit("get-chats", { userId: (member?._id || specialist?.specialist?._id || specialist?._id), search, currentPage: 1, limit: 20 })
          }}
          sx={{
            width: "100%",
            "& .MuiInputBase-input": {
              color: "black",
            },
          }}
          placeholder="Search.."
          slotProps={{
            input: {
              startAdornment: (
                <Icon sx={{ fontSize: "18px", mr: 1, color: "#858585" }}>
                  <Icons.Search />
                </Icon>
              ),
            },
          }}
        />
        <Stack
          spacing={0.25}
          ref={listRef}
          sx={{
            width: { md: 300 },
            flex: 1,
            overflowY: "auto",
          }}
          divider={<Divider />}
        >
          {(
            data?.records?.map((element, i) => (
              <Box
                key={i}
                sx={{
                  p: 1,
                  gap: 1,
                  display: "flex",
                  cursor: "pointer",
                  borderRadius: "6px",
                  alignItems: "center",
                  transition: "all ease 350ms",
                  ":hover": { bgcolor: "#00000010" },
                  bgcolor: chat?._id === element?._id ? "#00000010" : "",
                }}
                onClick={() => { handleChatActive(element) }}
              >
                <OnlineBadge
                  variant="dot"
                  overlap="circular"
                  isOnline={element?.isOnline}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                >
                  <Avatar
                    src={element?.user?.image}
                    sx={{ width: 40, height: 40 }}
                  />
                </OnlineBadge>
                <ListItemText
                  sx={{ m: 0 }}
                  primary={element?.user?.fullName || "Unknown user"}
                  secondary={
                    userServices.isMember && <Chip
                      size="small"
                      variant="specializationChip"
                      label={element?.specialization}
                      sx={{ color: "white", bgcolor: "blue.300" }}
                    />
                  }
                  slotProps={{
                    secondary: { component: "div" },
                    primary: { style: { fontWeight: "500", lineHeight: 1.3, textTransform: "capitalize" } },
                  }}
                />
              </Box>
            ))
          )}
          {loadings?.retrieveAll && (
            <Box sx={{ textAlign: "center", pb: 1 }}>
              <CircularProgress size={30} thickness={4} />
            </Box>
          )}
        </Stack>
      </Paper>
    </Grid>
  )
}

export default Users